// extracted by mini-css-extract-plugin
module.exports = {"total":"CartFooter__total___hAFmD","discount":"CartFooter__discount___UCpDv","footer":"CartFooter__footer___5ycOZ colors__text-dark___2vRHZ"};